var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preparation-analysis-chart-body__container",style:(("min-height: " + _vm.crudeScale + "px;"))},[_c('canvas',{key:_vm.chartKey,attrs:{"id":"analysisChart"}})])}
var staticRenderFns = []

export { render, staticRenderFns }